export default {
  "title": {
    "traceability": "Rastreabilidade do trabalho",
    "durationCharts": "Gráficos de duração",
    "avgTimesHistogram": "Tempo do histograma na planta/cliente (minutos)",
    "avgTimesPerArrive": "Distribuição de tempo por hora de chegada separada por processos"
  },
  "filters": {
    "startHour": "Hora de início",
    "startHourOptions": {
      "": "Todas",
      "0;": "00:00 horas",
      "1;": "01:00 horas",
      "2;": "02:00 horas",
      "3;": "03:00 horas",
      "4;": "04:00 horas",
      "5;": "05:00 horas",
      "6;": "06:00 horas",
      "7;": "07:00 horas",
      "8;": "08:00 horas",
      "9;": "09:00 horas",
      "10;": "10:00 horas",
      "11;": "11:00 horas",
      "12;": "12:00 horas",
      "13;": "13:00 horas",
      "14;": "14:00 horas",
      "15;": "15:00 horas",
      "16;": "16:00 horas",
      "17;": "17:00 horas",
      "18;": "18:00 horas"
    },
    "waitingLength": "Duração",
    "waitingLengthOptions": {
      "": "Todas",
      "0;30": "0:30 minutos",
      "30;60": "30:60 minutos",
      "60;90": "60:90 minutos",
      "90;120": "90:120 minutos",
      "120;150": "120:150 minutos",
      "150;180": "150:180 minutos",
      "180;210": "180:210 minutos",
      "210;240": "210:240 minutos",
      "240;270": "240:270 minutos",
      "270;300": "270:300 minutos",
      "300;": "300+ minutos"
    }
  },
  "table": {
    "place": "Planta/Cliente",
    "vehicle": "Veículo",
    "from": "Desde",
    "to": "Até"
  },
  "labels": {
    "avgPerVehicle": "Média por veículo"
  },
  "graphTooltip": {
    "plantTime": "Tempo da planta/cliente entre",
    "ocasion": "ocasiões",
    "minutes": "minutos",
    "proccess": "Processo",
    "comingTime": "Tempo de chegada",
    "averageDuration": "Duração média",
    "arrivalTime": "Hora de chegada à planta/cliente"
  },
  "fufillment": {
    "acomplishment": "Aplicação da lei",
    "bestPeriod": "melhora em relação ao período anterior",
    "befor": "Período anterior",
    "now": "Este Período",
    "howItGoes": "Como você está se saindo em relação ao objetivo",
    "goal": "Meta",
    "atRisk": "Em risco",
    "operation": "Operação",
    "date": "Data",
    "break": "Descanso de 8 horas",
    "breakUnder": "Descanso baixa",
    "time": "horas",
    "amountOfBreak": "Número de descanso",
    "amountOfUnacumplishment": "Número de violações",
    "amountOfManagement": "Número de procedimentos",
    "seeDetail": "Ver detalhe",
    "mainIndicator": "Principais indicadores",
    "manage": "Gestão",
    "fulfillment": "Observância",
    "unfulfillment": "violação",
    "homework": "Tarefa",
    "homeworkInfo": "Informações da tarefa",
    "_break": "Descanso",
    "driver": "Condutor",
    "type": "Tipo",
    "state": "Estado",
    "open": "Aberto",
    "timeOfUnfufillment": "Data padrão",
    "expired": "Expiração",
    "initBreak": "Início de pausa",
    "doneBreak": "Termo de pausa",
    "homeworkManagment": "Gerenciamento de tarefas",
    "reason": "Razão",
    "uploadFile": "Subir arquivo",
    "placeholderText": "Escreva o motivo pelo qual esse evento ocorreu",
    "closeButton": "Fechar desvio",
    "cancelButton": "Cancelar desvio",
    "driverRanking": "Classificação do piloto",
    "allIndicators": "Todos os indicadores",
    "title": "Principais indicadores",
    "titleSecond": "Principais indicadores",
    "categorie": "Categoria",
    "drivers": "Motoristas",
    "evolution": "Evolução da conformidade com todas as operações",
    "operationIndicator": "Indicadores todas as operações"
  },
  "detailTruck": {
    "gravity": "Gravidade",
    "all": "Todas",
    "form": "Forma",
    "empty": "Não há dados",
    "befor": "Período anterior",
    "to": "a",
    "driver": "Condutor",
    "team": "veículo",
    "failsDetail": "Detalhe da falha",
    "fails": "Falhas",
    "now": "Este periodo",
    "ranking": "Classificação",
    "inspections": "Inspeções",
    "averageNote": "Pontuação média",
    "evolutionDay": "Inspeções diárias de notas de evolução"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/detail/detailWaitingTimes.js